export default __webpack_public_path__ + "static/media/gorra-lana.ad9c1833.png";